import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import {
    setPendingReturnFilter
} from "../../store/orderSlice";

const Widget = ({ mainClass, textColorClass, isActive, value, label, sublabel, onClick }) => {
    return (
        <div className="col-md-6 col-xl">
            <div className={`widget-rounded-circle card-box summary-card-box cursor-pointer ${mainClass} ${isActive ? 'active' : ''}`} onClick={onClick}>
                <h6 className="text-truncate card-box-title">{label}</h6>
                <div className="row">
                    <div className='col-auto'><h5 className={`card-box-subtitle`}>{sublabel}</h5></div>
                    <div className='col'><h5 className={`card-box-value text-right ${textColorClass}`}>{value}</h5></div>
                </div>
            </div>
        </div>
    );
};

const StatusSummary = ({ orderState }) => {
    const dispatch = useDispatch();

    const statusSummary = orderState.returnRequestStatusSummary;
    // const trackingStatusSummary = orderState.returnRequestTrackingStatusSummary;
    const [selectedStatus, setSelectedStatus] = useState(orderState.pendingFilters.status ? orderState.pendingFilters.status : null);
    const [selectedTrackingStatus, setSelectedTrackingStatus] = useState(orderState.pendingFilters.trackingStatus ? orderState.pendingFilters.trackingStatus : null);
    const customStatus = orderState.pendingFilters.customStatus ? orderState.pendingFilters.customStatus : null;

    const onClickStatusFilter = (customStatusId) => {
        dispatch(setPendingReturnFilter({
            ...orderState.pendingFilters,
            customStatus: customStatusId,
            status: null,
            trackingStatus: null,
            currentPage: 1
        }));
    }

    useEffect(() => {
        setSelectedStatus(orderState.pendingFilters.status);
    }, [orderState.pendingFilters.status]);

    useEffect(() => {
        setSelectedTrackingStatus(orderState.pendingFilters.trackingStatus);
    }, [orderState.pendingFilters.trackingStatus]);

    const widgetsData = [
        {
            value: statusSummary && statusSummary.status_pending ? statusSummary.status_pending : 0,
            label: "Return Parcel - Pending / In Transit",
            sublabel: "[No Action Needed]",
            mainClass: 'card-box-info',
            isActive: customStatus == 1,
            onClick: () => onClickStatusFilter(1)
        },
        {
            value: statusSummary && statusSummary.status_not_processed ? statusSummary.status_not_processed : 0,
            label: "Return Parcel - Delivered But Not Processed",
            sublabel: "[Action Needed]",
            mainClass: 'card-box-danger',
            isActive: customStatus == 2,
            onClick: () => onClickStatusFilter(2)
        },
        {
            value: statusSummary && statusSummary.status_processed ? statusSummary.status_processed : 0,
            label: "Return Parcel - Delivered & Return Processed",
            sublabel: "[No Action Needed]",
            mainClass: 'card-box-success',
            isActive: customStatus == 3,
            onClick: () => onClickStatusFilter(3)
        },
        {
            value: statusSummary && statusSummary.status_not_paid ? statusSummary.status_not_paid : 0,
            label: "Return Fee Not Paid",
            sublabel: "[No Action Needed]",
            mainClass: 'card-box-warning',
            isActive: customStatus == 4,
            onClick: () => onClickStatusFilter(4)
        },
    ];

    return (
        <>
            <div className="row">
                {widgetsData.map((widget, index) => (
                    <Widget
                        key={'s' + index}
                        mainClass={widget.mainClass}
                        // textColorClass={widget.textColorClass}
                        value={widget.value}
                        label={widget.label}
                        sublabel={widget.sublabel}
                        onClick={widget.onClick}
                        isActive={widget.isActive ?? false}
                    />
                ))}
            </div>
        </>
    );
};

export default StatusSummary;
